export const artDesignTextContent = {
  headingText: "ART & Design",
  paraText_1: "GammaSlots crafts a perfect blend of innovative design and sleek animations to elevate your slot games into a visual masterpiece. With our unlimited character designs, stunning themes and captivating UI/UX, we create visually compelling slot games that keep your players hooked.",
  paraText_2: "Our designs bring together artistry and strategy that enhances user engagement by delivering unmatched user experience. We craft visually striking slot games that effortlessly hold the player's attention.",
  btnText: "View All Games",
  content: [
    {
      titleText: "Concept",
      imageSrc: "/assets/stock-img/art_design_img_01.webp",
    },
    {
      titleText: "Rough Color",
      imageSrc: "/assets/stock-img/art_design_img_02.webp",
    },
    {
      titleText: "Final Output",
      imageSrc: "/assets/stock-img/art_design_img_03.webp",
    },
  ],
};
